import React, { useEffect, useState, useRef } from 'react';
//import axios from 'axios';
import { useTranslation } from 'react-i18next';
//import i18n from '../i18n';
import api from '../services/api';
import {  useLocation, useNavigate } from 'react-router-dom';
import { useContactsPermission } from '../services/requestContactsAccess';


function ImportContacts({ socket, email, prompt, contacts, setContacts }) {
  // const [contacts, setContacts] = useState([]);
  const [contactStatuses, setContactStatuses] = useState({});
const { t } = useTranslation();
const location = useLocation();
const navigate = useNavigate();

const fromDiscussionId = location.state?.fromDiscussion;



  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const inviteMessage = t('contacts.sms') + ' https://dunpayslointain.22web.org/clavardage/';
const [settingsLoaded, setSettingsLoaded] = useState(false);
const [allowContacts, setAllowContacts] = useState(false);
const token = localStorage.getItem('token');
const allowContactsRef = useRef(false);

useEffect(() => {
  setContacts([]);
}, []);

const { requestContactsAccess, modal } = useContactsPermission(
  allowContactsRef, // depuis vos settings
  token,
  setAllowContacts  // met à jour le state local immédiatement
);

useEffect(() => {
  const fetchSettings = async () => {
    try {
      const res = await api.get(`${API_URL}/api/profil/settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const val = res.data.settings?.allowContacts ?? false;
      setAllowContacts(val);
      allowContactsRef.current = val; // ← valeur fraîche immédiatement
    } catch (e) {
      console.error(e);
    } finally {
      setSettingsLoaded(true);
    }
  };
  fetchSettings();
}, []);

// 2. Seulement quand settingsLoaded est true, on lance la demande
useEffect(() => {
  if (!settingsLoaded) return;
  
  requestContactsAccess().then((granted) => {
        if (granted) {
      proceedWithImport();
    } else {
      setContacts([]); // ← vide la liste si refusé
	setIsChecking(false);
    }
  });
}, [settingsLoaded]);

const [isChecking, setIsChecking] = useState(true);

const proceedWithImport = () => {
  const fields = ['displayName', 'name', 'emails', 'photos', 'phoneNumbers'];
//  const options = { filter: '', multiple: true };

  navigator.contacts.find(fields, (contacts) => { // Fonction de succès classique
    const formatted = [];
    contacts.forEach((contact, index) => {
      const baseContact = {
        id: index,
        name: contact.displayName || (contact.name ? contact.name.formatted : t('contacts.unknowncontact')),
        email: contact.emails?.[0]?.value || null,
        phoneNumber: contact.phoneNumbers?.[0]?.value || null,
        photo: null, // par défaut
      };

      // Pour gérer les photos de contact de façon asynchrone
      if (contact.photos?.[0]?.value) {
        window.resolveLocalFileSystemURL(contact.photos[0].value, (fileEntry) => {
          fileEntry.file((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              baseContact.photo = reader.result; // base64
              formatted.push(baseContact);
              if (formatted.length === contacts.length) { // Quand tous les contacts sont traités
                formatted.sort((a, b) => a.name.localeCompare(b.name));
                setContacts(formatted);
                checkContacts(formatted);
		localStorage.setItem('contacts', JSON.stringify(formatted));
		setIsChecking(false); 

              }
            };
            reader.readAsDataURL(file);
          });
        }, () => { 
          formatted.push(baseContact); // En cas d'erreur, ajouter le contact sans photo
          if (formatted.length === contacts.length) {
            formatted.sort((a, b) => a.name.localeCompare(b.name));
            setContacts(formatted);
localStorage.setItem('contacts', JSON.stringify(formatted));
            checkContacts(formatted);
		setIsChecking(false); 
		          }
        });
      } else {
        formatted.push(baseContact); // Ajouter le contact sans photo
        if (formatted.length === contacts.length) {
          formatted.sort((a, b) => a.name.localeCompare(b.name));
          setContacts(formatted);
localStorage.setItem('contacts', JSON.stringify(formatted));
          checkContacts(formatted);
	setIsChecking(false);
	        }
      }
    });
  }, (err) => {
    console.error('Erreur lors de la récupération des contacts:', err);
  });
};


  const checkContacts = (formattedContacts) => {
  api.post(`${API_URL}/api/list_users/check-contacts`, {
    contacts: formattedContacts.map(c => ({ 
      id: c.id, 
      email: c.email,
      phoneNumber: c.phoneNumber,
      profileImage: c.profileImage,
    }))
  })
  .then((res) => {
    setContactStatuses((prev) => ({ ...prev, ...res.data }));
  })
  .catch((err) => {
    if (err.response?.status === 403) {
      setContacts([]);
      navigate('/');
    } else {
      console.error('Erreur check contacts:', err);
    }
  });
};


  const sendSMS = (phoneNumber) => {
    window.location.href = `sms:${phoneNumber}?&body=${encodeURIComponent(inviteMessage)}`;
  };

const sendEmail = (email) => {
  //const subject = "Invitation à rejoindre l'application";
  //const body = inviteMessage; // ton message d'invitation

  window.location.href = `mailto:${email}?subject=${encodeURIComponent(inviteMessage)}`;
};

const handleBackToDiscussions = () => {
    if (fromDiscussionId) {
      // Revenir à la discussion fullscreen
      navigate('/', {
        state: { reopenDiscussionId: fromDiscussionId },
      });
    } else {
      navigate(-1); // comportement par défaut
    }
  };
//const token = localStorage.getItem('token');

const navigateToProfile = (userId) => {
  navigate(`/profile/${userId}`);
};


  return (
    <div className="import-contacts">
{modal}
      <h2>{t('contacts.title')}</h2>
{/* Chargement */}
{isChecking && (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '24px 16px', justifyContent: 'center' }}>
    <div className="spinner" />
    <span style={{ fontSize: 13, color: 'var(--text-color)', opacity: 0.5 }}>
      {t('discussion.chargement')}
    </span>
  </div>
)}

      {!isChecking && contacts.length > 0 && (
        <ul className="contact-list">
          {contacts.map((contact) => {
            const status = contactStatuses[String(contact.id)] || {};
            const isEnregistre = status.enregistre === true;
            return (
              <li key={contact.id} className="contact-item">
{isEnregistre ? (
  status.profileImage ? (
    <img
      src={`${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${status._id}?token=${token}&type=image&thumb=true&profile=true&t=${status.profileImageUpdatedAt}`}
      alt="Image de profil"
      className="contact-photo"
      onClick={e => { e.stopPropagation(); navigateToProfile(status._id); }}
    />
  ) : (
    <div
      className="contact-photo"
      onClick={e => { e.stopPropagation(); navigateToProfile(status._id); }}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', background: 'var(--toolbar-bg)', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer', flexShrink: 0 }}
    >
      {contact.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)}
    </div>
  )
) : (
  contact.photo ? (
    <img
      src={contact.photo}
      alt={contact.name}
      className="contact-photo"
    />
  ) : (
    <div
      className="contact-photo"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', background: 'var(--border-color)', color: 'var(--text-color)', fontSize: 14, fontWeight: 600, flexShrink: 0 }}
    >
      {contact.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)}
    </div>
  )
)}
                <span className="contact-name">{contact.name}</span>
                <div className="contact-status">
                  {!isEnregistre && contact.phoneNumber && (
<button
  onClick={async () => {
const { alert, confirm} = prompt;

      const confirmSend = await confirm(
        t('contacts.alertsms')
      );
      if (confirmSend) {
        sendSMS(contact.phoneNumber);
      }
    }}

  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  title={t('contacts.alertsms')}
>
  <i className="ti ti-message" style={{ fontSize: '16px', color: 'var(--text-color)' }} aria-hidden="true" />
</button>
  
)}
{!isEnregistre && contact.email && (
<button
  onClick={async () => {
const { alert, confirm} = prompt;

      const confirmSend = await confirm(
        t('contacts.alertsms')
      );
      if (confirmSend) {
        sendEmail(contact.email);
      }
    }}

  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  title="Email"
>
  <i className="ti ti-at" style={{ fontSize: '16px', color: 'var(--text-color)' }} aria-hidden="true" />
</button>

)}

                  {status.enregistre && <span className="status-icon">🟢</span>}
                  {status.connecte && <span className="status-icon">🟡</span>}
                </div>
              </li>
            );
          })}
        </ul>
       )}
        {/* Aucun contact */}
{!isChecking && contacts.length === 0 && (
  <p>{t('contacts.nocontact')}</p>
)}
     

    </div>
  );
}

export default ImportContacts;
